export default "__VITE_ASSET__02rd2qHO__"